(function () {
  function init(root) {
    if (!root || root.dataset.stgpReady === '1') return;
    root.dataset.stgpReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-stgp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-stgp-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(id, focusTab) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-stgp-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-stgp-panel') === id;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-stgp-tab'), false);
      });
      tab.addEventListener('keydown', function (e) {
        var next = index;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(tabs[next].getAttribute('data-stgp-tab'), true);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-stgp-section]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-stgp-section]');
    if (root) {
      delete root.dataset.stgpReady;
      init(root);
    }
  });
})();
